'use client';

import { useSearchParams } from 'next/navigation';
import VehicleSkeletonLayout from './VehicleSkeletonLayout';

export default function VehicleLoadingSkeleton() {
  const searchParams = useSearchParams();
  const isLite = searchParams?.get('ct') === '1';

  return <VehicleSkeletonLayout isLite={isLite} />;
}
